import { useContext } from 'react';
import { MyAccountContext } from './store';
// Services

import Services from './services';
// Actions
import * as Actions from './actions';

const useMyaccountState = () => {
  const [state, dispatch] = useContext(MyAccountContext);
  const store = {
    state: { ...state },
    services: { ...Services(dispatch, Actions) },
  };

  return store;
};

export { useMyaccountState };
